// @flow

// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'

// Utils
import traverse from 'fc-utils/traverse'
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Constants
import { TREE, BRANCH } from '../constants'

export default createSelector(
  [traverse([TREE, BRANCH])],
  function (grids: { [number]: Object }): Array<Object> {
    return emptyArrayOr(_map(grids))
  }
)
